const read = (key: string): string | undefined => {
  try {
    const value = localStorage.getItem(key);
    if (!value) return undefined;
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  } catch {
    return undefined;
  }
};

const readSession = (key: string): string | undefined => {
  try {
    return sessionStorage.getItem(key) || undefined;
  } catch {
    return undefined;
  }
};

const tokenPayload = (token?: string): Record<string, unknown> => {
  if (!token) return {};
  try {
    const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(payload));
  } catch {
    return {};
  }
};

export const isNavbarLoggedIn = () => {
  const payload = tokenPayload(read("refresh_token"));
  return typeof payload.exp === "number" && Date.now() < payload.exp * 1000;
};

export const navbarEmail = () => {
  const payload = tokenPayload(read("access_token"));
  const tokenEmail = [payload.email, payload.user_name, payload.username].find(
    (value): value is string => typeof value === "string" && value.includes("@"),
  );

  return read("user_name") || readSession("navbar_profile_email") || tokenEmail;
};

export const rememberNavbarEmail = (email?: string) => {
  if (!email) return;
  try {
    sessionStorage.setItem("navbar_profile_email", email);
  } catch {
    // Session storage can be unavailable in privacy-restricted embeds.
  }
};

export const navbarInitials = () => {
  const email = navbarEmail();
  return email?.trim().charAt(0).toUpperCase() || "";
};

export const rememberNavbarReturnUrl = () => {
  try {
    if (window.location.pathname !== "/fehler") {
      // Match the legacy navbar: store the full href so the hash is preserved.
      // safeInternalPath() reduces this same-origin URL back to a path at redirect time.
      localStorage.setItem("afterLoginRedirectURL", window.location.href);
    }
  } catch {
    // Storage can be unavailable in privacy-restricted embeds.
  }
};
